import type { Constructor, SmartZoneAttributes } from '../shared-types';
import type { fabric } from 'fabric';
import {
  hasEmbeddedTextBehaviors,
  hasSmartZoneBehaviors,
  isFrame,
} from './guards';

export interface SmartZoneRecordConfig {
  enabled?: boolean;
  attributes?: SmartZoneAttributes;
}

export interface SmartZoneConfig {
  enabled: boolean;
  // e.g., "features", "requirements", "epics"
  configurations?: Record<string, SmartZoneRecordConfig>;
}

interface SmartZoneBehaviors {
  __hasSmartZoneBehaviors: true;
  smartZoneConfig?: SmartZoneConfig;
  smartZoneTitle(): string;
}

export type SmartZoneObject = SmartZoneBehaviors & fabric.Object;

export const isSmartZoneCapable = (
  obj: fabric.Object
): obj is fabric.Object & SmartZoneBehaviors =>
  hasSmartZoneBehaviors(obj) && isFrame(obj);

export const isSmartZone = (obj: fabric.Object): obj is SmartZoneObject =>
  !!(isSmartZoneCapable(obj) && obj.smartZoneConfig?.enabled);

// eslint-disable-next-line @typescript-eslint/no-redeclare
function SmartZoneBehaviors<T extends Constructor<fabric.Object>>(Base: T) {
  return class WithSmartZoneBehaviors
    extends Base
    implements SmartZoneBehaviors
  {
    __hasSmartZoneBehaviors = true as const;
    smartZoneConfig?: SmartZoneConfig;

    serializedKeys = [
      // @ts-expect-error serializedKeys is declared on subclasses
      ...this.serializedKeys,
      'smartZoneConfig',
    ];

    smartZoneTitle() {
      if (hasEmbeddedTextBehaviors(this)) {
        return this.plainText() || 'Smart zone';
      }
      return 'Smart zone';
    }
  };
}

export default SmartZoneBehaviors;
